import { createSlice, type PayloadAction } from '@reduxjs/toolkit';
import { useSelector } from 'react-redux';
import { QuestionSetConfig } from '../types/GameplayTypes';

type GameConfigState = {
	questionSet: QuestionSetConfig | undefined;

	// Team configuration
	teamNames: [string, string];

	// Accessibility settings
	sensorySensitivityMode: boolean;
};

const initialState: GameConfigState = {
	questionSet: undefined,
	teamNames: ['Blue Team', 'Red Team'],
	sensorySensitivityMode: false,
};

export const gameConfigStore = createSlice({
	name: 'gameConfig',
	initialState,
	reducers: {
		setQuestionSet: (state, action: PayloadAction<QuestionSetConfig | undefined>) => {
			state.questionSet = action.payload;
		},
		setTeamNames: (state, action: PayloadAction<[string, string]>) => {
			state.teamNames = action.payload;
		},
		setSensorySensitivityMode: (state, action: PayloadAction<boolean>) => {
			state.sensorySensitivityMode = action.payload;
		},
		resetGameConfig: () => {
			return initialState;
		},
	},
	selectors: {
		teamNames: (state) => state.teamNames,
		questionSet: (state) => state.questionSet,
		sensorySensitivityMode: (state) => state.sensorySensitivityMode,
	},
});

export const useGameConfigSelector = useSelector.withTypes<{ gameConfig: GameConfigState; }>();